<template>
    <div class="cabinet-supplier-detail mt-0">
        <filters-loading v-if="filtersLoading" />
        <section
            v-else
            class="filters-panel filters-panel--border-bottom row filters-panel__row"
        >
            <div
                v-if="!isCategoryPage"
                class="col-lg-2 filters-panel__col d-none d-lg-block"
            >
                <select-picker
                    :current-value="filter.categories.value"
                    :options="categories"
                    key-value="CategoryID"
                    key-title="Name"
                    select-title="Категория:"
                    select-width="100%"
                    :is-multiple="true"
                    :classes="['select']"
                    @onChange="onSelectPickerChange('categories', $event)"
                />
            </div>
            <div
                v-if="!isCategoryPage"
                class="col-lg-2 filters-panel__col d-none d-lg-block"
            >
                <select-picker
                    :current-value="filter.types.value"
                    :options="typesByCategories"
                    key-value="TypeID"
                    key-title="Name"
                    select-title="Вид изделия:"
                    select-width="100%"
                    :is-multiple="true"
                    :classes="['select']"
                    @onChange="onSelectPickerChange('types', $event)"
                />
            </div>
            <div class="col-lg-2 filters-panel__col d-none d-lg-block">
                <select-picker
                    :current-value="filter.materials.value"
                    :options="materials"
                    key-value="MaterialID"
                    key-title="Name"
                    select-title="Материал:"
                    select-width="100%"
                    :is-multiple="true"
                    :classes="['select']"
                    @onChange="onSelectPickerChange('materials', $event)"
                />
            </div>

            <div class="filters-panel__col d-none d-lg-block">
                <select-picker
                    :current-value="filter.finenesses.value"
                    :options="finenessesByMaterials"
                    key-value="FinenessID"
                    key-title="Value"
                    select-title="Проба:"
                    select-width="100%"
                    :is-multiple="true"
                    :classes="['select']"
                    @onChange="onSelectPickerChange('finenesses', $event)"
                />
            </div>
            <div class="col-lg-2 filters-panel__col d-none d-lg-block">
                <select-picker
                    :current-value="filter.insertMaterials.value"
                    :options="insertMaterials"
                    key-value="MaterialID"
                    key-title="Name"
                    select-title="Материал вставки:"
                    select-width="100%"
                    :is-multiple="true"
                    :classes="['select']"
                    @onChange="onSelectPickerChange('insertMaterials', $event)"
                />
            </div>
            <div class="filters-panel__col d-none d-lg-block">
                <select-picker
                    :current-value="filter.collections.value"
                    :options="collectionsByBrand"
                    key-value="CollectionID"
                    key-title="Name"
                    select-title="Коллекция:"
                    select-width="100%"
                    :is-multiple="true"
                    :classes="['select']"
                    @onChange="onSelectPickerChange('collections', $event)"
                />
            </div>
            <div class="filters-panel__col d-none d-lg-block">
                <select-picker
                    :current-value="filter.genders.value"
                    :options="genders"
                    key-value="id"
                    key-title="title"
                    select-title="Для кого:"
                    select-width="100%"
                    :is-multiple="true"
                    :classes="['select']"
                    @onChange="onSelectPickerChange('genders', $event)"
                />
            </div>
            <div
                v-if="isCategoryDecoration"
                class="filters-panel__col d-none d-lg-block"
            >
                <select-picker
                    :current-value="filter.garnitures.value"
                    :options="garnituresOpts"
                    key-value="id"
                    key-title="title"
                    select-title="Гарнитур:"
                    select-width="100%"
                    :is-multiple="true"
                    :classes="['select']"
                    @onChange="onSelectPickerChange('garnitures', $event)"
                />
            </div>
            <div class="filters-panel__col d-none d-lg-block">
                <button
                    v-if="!isAllDefaultValues"
                    type="button"
                    class="cabinet-btn cabinet-btn--default"
                    @click="resetFilters()"
                >
                    Сбросить
                </button>
            </div>
        </section>

        <section>
            <div
                class="flex flex-column flex-justify-sb mobile-filter"
                :class="{ 'mobile-filter--open': level1mFilter }"
            >
                <div class="mobile-filter__wrap">
                    <div
                        class="flex flex-justify-sb flex-align-center mobile-filter__header"
                    >
                        <div class="h3 mobile-filter__title">
                            Фильтр
                            <span class="mobile-filter__selected-count"></span>
                        </div>
                        <button
                            type="button"
                            class="mobile-filter__close-btn"
                            @click="level1mFilter = false"
                        ></button>
                    </div>

                    <ul class="mobile-filter__list">
                        <li
                            v-for="(filterKey, i) in filterComputed"
                            :key="i"
                            class="mobile-filter__list-item"
                            @click="setlevel2mFilters(filterKey)"
                        >
                            <div class="d-flex justify-content-between">
                                {{ filter[filterKey].title }}
                                <div
                                    v-if="!filter[filterKey].isDefault"
                                    class="mobile-filter__selected-label d-flex align-items-center"
                                >
                                    {{ filter[filterKey].value.length }}
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>

                <div class="d-flex p-3 mobile-filter__footer">
                    <button
                        type="button"
                        class="cabinet-btn mr-3"
                        @click="level1mFilter = false"
                    >
                        Показать
                    </button>
                    <button
                        type="button"
                        class="cabinet-btn cabinet-btn--default"
                        @click="resetFilters()"
                    >
                        Сбросить
                    </button>
                </div>
            </div>

            <div
                v-if="!!level2mFilter"
                id="mobile-filter-level2"
                class="flex flex-column flex-justify-sb mobile-filter"
                :class="{ 'mobile-filter--open': !!level2mFilter }"
            >
                <div class="mobile-filter__wrap">
                    <div
                        class="flex flex-justify-sb flex-align-center mobile-filter__header"
                    >
                        <button
                            type="button"
                            class="mobile-filter__back-btn"
                            @click="level2mFilter = false"
                        ></button>
                        <div class="h3 mobile-filter__title">
                            {{ filter[level2mFilter].title }}
                        </div>
                        <div></div>
                    </div>

                    <ul class="mobile-filter__list">
                        <!-- {{ this[filter[level2mFilter].srcName] }} -->
                        <!-- eslint-disable -->
                        <li
                            v-for="(item, i) in this[
                                filter[level2mFilter].srcName
                            ]"
                            :key="i"
                            class="mobile-filter__list-item"
                        >
                            <label class="custom-checkbox"
                            >{{ item[filter[level2mFilter].srcKeyTitle] }}
                                <input
                                    v-model="filter[level2mFilter].value"
                                    type="checkbox"
                                    :value="
                                        item[filter[level2mFilter].srcKeyVal]
                                    "
                                    @change="onFilterChange(level2mFilter)"
                                />
                                <span class="custom-checkbox__checkmark"></span>
                            </label>
                        </li>
                        <!-- eslint-enable -->
                    </ul>
                </div>

                <div class="d-flex p-3 mobile-filter__footer">
                    <button
                        type="button"
                        class="cabinet-btn mr-3"
                        @click="closeAllmFilters"
                    >
                        Показать
                    </button>
                    <button
                        type="button"
                        class="cabinet-btn cabinet-btn--default"
                        @click="resetFilters()"
                    >
                        Сбросить
                    </button>
                </div>
            </div>
        </section>

        <template v-if="catalogMode == 'products'">
            <products-loading v-if="loading" />

            <div
                v-else-if="!paginatedProducts.length"
                class="w-md-50 text-center ml-auto mr-auto pt-5 pb-5"
            >
                <img
                    v-if="search.length === 0"
                    src="/img/icons/empty-goods.svg"
                    class="dashboard-empty__img ofi"
                />
                <img
                    v-else
                    src="/img/icons/empty-search.svg"
                    class="dashboard-empty__img dashboard-empty__img--search ofi"
                />
                <div class="dashboard-empty__title pt-5">
                    {{
                        search || !isAllDefaultValues || requestForCategories
                            ? 'По вашему запросу ничего не найдено.'
                            : `Коллекция бренда ${brand.BrandName} в процессе формирования`
                    }}
                </div>
            </div>

            <div v-show="!loading && paginatedProducts.length">
                <section class="cabinet-table-options-wrap mb-0">
                    <div
                        class="cabinet-table-options flex flex-align-center pt-0 pb-0"
                    >
                        <div class="d-none d-md-block">
                            {{
                                pagination.page * pagination.pageSize +
                                    1 -
                                    pagination.pageSize
                            }}
                            -
                            {{
                                Math.min(
                                    pagination.page * pagination.pageSize,
                                    pagination.totalProducts
                                )
                            }}

                            из {{ pagination.totalProducts }}
                        </div>

                        <div
                            class="cabinet-table-options__sort flex flex-align-center ml-md-auto justify-content-sm-between"
                        >
                            <div
                                class="dropdown bootstrap-select select cabinet__catalog-select mr-2"
                            >
                                <select-picker
                                    :current-value="sort"
                                    :options="sortVariations"
                                    key-value="value"
                                    key-title="title"
                                    select-width="176"
                                    :classes="['select']"
                                    @onChange="onSortChange($event)"
                                />
                            </div>
                            <div class="position-relative d-lg-none">
                                <button
                                    type="button"
                                    class="cabinet-btn cabinet-btn--default filters-panel__mob-btn d-none d-md-block ml-3 js-open-mob-filters"
                                    @click="level1mFilter = true"
                                >
                                    Фильтры
                                </button>
                                <button
                                    type="button"
                                    class="cabinet-btn-icon cabinet-btn-icon--default cabinet-btn-icon--filter d-md-none"
                                    @click="level1mFilter = true"
                                ></button>
                                <div
                                    v-if="appliedFiltersCount"
                                    class="mobile-filter__selected-label mobile-filter__selected-label--circle"
                                >
                                    {{ appliedFiltersCount }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <section
                        class="cabinet-table-options flex flex-justify-sb flex-align-center d-flex"
                    >
                        <div class="d-none d-md-block">
                            <select-picker
                                :current-value="pagination.pageSize"
                                :options="pageSizes"
                                key-value="id"
                                key-title="title"
                                select-width="80"
                                :classes="['select', 'select--small']"
                                @onChange="onPageSizeChange($event)"
                            />
                        </div>
                        <div class="d-md-none">
                            {{
                                Math.min(
                                    pagination.page * pagination.pageSize,
                                    pagination.totalProducts
                                )
                            }}

                            из {{ pagination.totalProducts }}
                        </div>

                        <div class="d-none d-md-flex">
                            <table-pagination
                                :current-page="pagination.page"
                                :total-pages="pagination.totalPages"
                                :total-products="pagination.totalProducts"
                                :disable-scroll-top="isMobile"
                                @setPage="onSetPage($event)"
                            />
                        </div>
                    </section>
                </section>

                <section
                    class="d-flex flex-wrap justify-content-between"
                    :class="{
                        'cabinet__catalog--table': view === 'list',
                        'cabinet__catalog-container': view !== 'list'
                    }"
                >
                    <product-item
                        v-for="product in paginatedProducts"
                        :key="product.ItemID"
                        :product="product"
                    />

                    <!-- Костыль для верстки -->
                    <div class="cabinet__catalog-item"></div>
                    <div class="cabinet__catalog-item"></div>
                    <div class="cabinet__catalog-item"></div>
                </section>

                <section
                    class="cabinet-table-options flex flex-justify-sb flex-align-center d-none d-md-flex"
                >
                    <select-picker
                        :current-value="pagination.pageSize"
                        :options="pageSizes"
                        key-value="id"
                        key-title="title"
                        select-width="80"
                        :classes="['select', 'select--small']"
                        @onChange="onPageSizeChange($event)"
                    />

                    <table-pagination
                        :current-page="pagination.page"
                        :total-pages="pagination.totalPages"
                        :total-products="pagination.totalProducts"
                        :disable-scroll-top="isMobile"
                        @setPage="onSetPage($event)"
                    />
                </section>

                <section
                    v-if="pagination.page < pagination.totalPages"
                    class="flex flex-column flex-align-center pb-4 d-md-none"
                >
                    <button
                        type="button"
                        class="cabinet-btn cabinet-btn--default"
                        :disabled="pagination.page >= pagination.totalPages"
                        @click="updateProductsList(pagination.page + 1, true)"
                    >
                        Загрузить еще
                    </button>
                </section>
            </div>
        </template>
        <template v-if="catalogMode == 'garnitures'">
            <catalog-garnitures-list
                :page-sizes="[16, 32, 48, 60]"
                :filter="filter"
                :search-text="search"
                :filter-time-stamp="garnituresFilterTimeStamp"
                :brand-catalog-brand-id="brand.BrandID"
                @toggleCatalogMode="toggleCatalogMode"
                @changeListView="changeListView"
            />
        </template>
    </div>
</template>

<script>
import _ from 'lodash'
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import ClickOutside from 'vue-click-outside'

import getNameById from '@/mixins/getNameById'
import ProductItem from '@/components/Public/Brand/Products/ProductItem'
import SelectPicker from '@/components/Elements/SelectPicker'
import TablePagination from '@/components/Cabinet/Pagination/TablePagination'
import initSelectPicker from '@/mixins/initSelectPicker'
import onResize from '@/mixins/on-resize'
import CatalogGarnituresList from '@/components/Cabinet/Retailer/Catalog/GarnituresList'
import FiltersLoading from '@/components/Cabinet/Retailer/Loading/FiltersLoadingNoSearch'
import ProductsLoading from '@/components/Cabinet/Retailer/Loading/ProductsLoading'

let pageSizes = [16, 32, 48, 60].map(item => {
    return {
        id: item,
        title: item
    }
})

export default {
    name: 'PublicBrandProducts',
    components: {
        ProductItem,
        SelectPicker,
        TablePagination,
        CatalogGarnituresList,
        FiltersLoading,
        ProductsLoading
    },
    directives: {
        ClickOutside
    },
    mixins: [initSelectPicker, getNameById, onResize],
    props: {
        brand: {
            type: Object,
            required: true
        },
        requestForCategories: {
            type: Boolean,
            required: false,
            default: false
        },
        isCategoryPage: {
            type: Boolean,
            required: false,
            default: false
        },
        filter2subcategories: {
            type: [Object, String],
            required: false
        }
    },
    data() {
        return {
            search: '',
            view: 'grid',
            sortVariations: [
                {
                    value: 'New:dsc',
                    title: 'Сначала новинки'
                },
                {
                    value: 'Price:asc',
                    title: 'По цене ↑'
                },
                {
                    value: 'Price:dsc',
                    title: 'По цене ↓'
                },
                {
                    value: 'Weight:asc',
                    title: 'По весу ↑'
                },
                {
                    value: 'Weight:dsc',
                    title: 'По весу ↓'
                },
                {
                    value: 'Article:dsc',
                    title: 'По артикулу ↑'
                },
                {
                    value: 'Article:asc',
                    title: 'По артикулу ↓'
                }
            ],
            garnituresOpts: [
                {
                    id: 1,
                    title: 'Входит в гарнитур'
                }
            ],
            filter: {
                categories: {
                    title: 'Категория',
                    srcName: 'categories', //name of store arr
                    srcKeyVal: 'CategoryID',
                    srcKeyTitle: 'Name',
                    value: [],
                    defaultValArrName: 'categoriesValuesArr',
                    isDefault: true, //если default, то параметры не отправляются в запрос
                    apiFilterName: 'categories'
                },
                types: {
                    title: 'Вид изделия',
                    srcName: 'typesByCategories',
                    srcKeyVal: 'TypeID',
                    srcKeyTitle: 'Name',
                    value: [],
                    defaultValArrName: 'typesValuesArr',
                    isDefault: true,
                    apiFilterName: 'types'
                },
                materials: {
                    title: 'Материал',
                    srcName: 'materials',
                    srcKeyVal: 'MaterialID',
                    srcKeyTitle: 'Name',
                    value: [],
                    defaultValArrName: 'materialsValuesArr',
                    isDefault: true,
                    apiFilterName: 'materials'
                },
                finenesses: {
                    title: 'Проба',
                    srcName: 'finenessesByMaterials',
                    srcKeyVal: 'FinenessID',
                    srcKeyTitle: 'Value',
                    value: [],
                    defaultValArrName: 'finenessesValuesArr',
                    isDefault: true,
                    apiFilterName: 'finenesses'
                },
                insertMaterials: {
                    title: 'Материал вставки',
                    srcName: 'insertMaterials',
                    srcKeyVal: 'MaterialID',
                    srcKeyTitle: 'Name',
                    value: [],
                    defaultValArrName: 'insertMaterialsValuesArr',
                    isDefault: true,
                    apiFilterName: 'inserts_materials'
                },
                collections: {
                    title: 'Коллекция',
                    srcName: 'collectionsByBrand',
                    srcKeyVal: 'CollectionID',
                    srcKeyTitle: 'Name',
                    value: [],
                    defaultValArrName: 'collectionsValuesArr',
                    isDefault: true,
                    apiFilterName: 'collections'
                },
                garnitures: {
                    title: 'Гарнитур',
                    srcName: 'garnituresOpts',
                    srcKeyVal: 'id',
                    srcKeyTitle: 'title',
                    value: [],
                    defaultValArrName: '',
                    isDefault: true,
                    apiFilterName: 'only_has_sets'
                },
                genders: {
                    title: 'Для кого',
                    srcName: 'genders',
                    srcKeyVal: 'id',
                    srcKeyTitle: 'title',
                    value: [],
                    defaultValArrName: '',
                    isDefault: true,
                    apiFilterName: 'genders'
                }
            },
            level1mFilter: false,
            level2mFilter: false,
            pageSizes,
            loading: true,
            filtersLoading: true,
            catalogMode: 'products', //'garnitures'
            garnituresFilterTimeStamp: ''
        }
    },
    computed: {
        ...mapState('user', ['user']),
        ...mapState('publicProducts', [
            'products',
            'mobileProducts',
            'pagination',
            'sort'
        ]),
        ...mapState('categories', { categories: 'supplierCategories' }),
        ...mapGetters('categories', {
            categoriesValuesArr: 'supplierCategoriesValuesArr'
        }),
        ...mapState('collections', { collections: 'supplierCollections' }),
        ...mapGetters('collections', {
            getCollectionsByBrand: 'getSupplierCollectionsByBrand',
            collectionsValuesArr: 'supplierCollectionsValuesArr'
        }),
        ...mapState('types', { types: 'supplierTypes' }),
        ...mapGetters('types', {
            getTypesByCategories: 'getSupplierTypesByCategories',
            typesValuesArr: 'supplierTypesValuesArr'
        }),
        ...mapState('materials', { materials: 'supplierMaterials' }),
        ...mapGetters('materials', {
            materialsValuesArr: 'supplierMaterialsValuesArr'
        }),
        ...mapState('finenesses', { finenesses: 'supplierFinenesses' }),
        ...mapGetters('finenesses', {
            getFinenessesByMaterials: 'getSupplierFinenessesByMaterials',
            finenessesValuesArr: 'supplierFinenessesValuesArr',
            getFinenessesNamesArr: 'getSupplierFinenessesNamesArr'
        }),
        ...mapState('insert', { insertMaterials: 'supplierInsertMaterials' }),
        ...mapGetters('insert', {
            insertMaterialsValuesArr: 'supplierInsertMaterialsValuesArr'
        }),
        ...mapState('genders', { genders: 'userGenders' }),
        ...mapGetters(['publicSearchGlobal']),
        typesByCategories() {
            return this.getTypesByCategories(this.filter.categories.value)
        },
        collectionsByBrand() {
            return this.getCollectionsByBrand([this.$route.params.id])
        },
        finenessesByMaterials() {
            return this.getFinenessesByMaterials(this.filter.materials.value)
        },
        finenessesNamesArr() {
            return this.getFinenessesNamesArr(this.filter.finenesses.value)
        },
        isAllDefaultValues() {
            return (
                Object.keys(this.filter).filter(
                    item => !this.filter[item].isDefault
                ).length === 0
            )
        },
        appliedFiltersCount() {
            const flterIsCategoryPage = Object.keys(this.filter)
                .filter(el => el !== 'types' && el !== 'categories')
                .filter(item => this.filter[item].value.length).length

            const filterDefault = Object.keys(this.filter).filter(
                item => this.filter[item].value.length
            ).length

            return this.isCategoryPage ? flterIsCategoryPage : filterDefault
        },
        paginatedProducts() {
            if (document.documentElement.clientWidth > 767) {
                return this.products
            }
            return this.mobileProducts
        },
        //если выбрана категория украшения
        isCategoryDecoration() {
            return (
                this.filter.categories.value.length == 1 &&
                this.filter.categories.value[0] == 1
            )
        },
        filterComputed() {
            const flterIsCategoryPage = Object.keys(this.filter).filter(
                el => el !== 'types' && el !== 'categories'
            )

            return this.isCategoryPage
                ? flterIsCategoryPage
                : Object.keys(this.filter)
        }
    },
    watch: {
        wwidth: function(val) {
            if (this.view === 'list' && val < 1024) {
                this.view = 'grid'
            }
        },
        isCategoryDecoration: function(val) {
            if (!val) {
                if (this.catalogMode == 'garnitures') {
                    this.toggleCatalogMode('products')
                }

                this.filter.garnitures.value = []
                this.filter.garnitures.isDefault = true
            }
        },
        filter2subcategories(type) {
            if (type === 'reset') {
                this.resetFilters()
            } else {
                this.onSelectPickerChange('types', [type.TypeID])
            }
        },
        publicSearchGlobal() {
            this.updateProductsListFunc()
        }
    },
    created() {
        if (this.$route.path !== '/catalog/category/all') {
            this.clearPublicSearchGlobal()
        }

        this.setCartPublicFromLocStor()

        this.filter2subcategories
            ? this.onSelectPickerChange('types', [
                  this.filter2subcategories.TypeID
              ])
            : null
    },
    async mounted() {
        this.setPreset()
        if (this.catalogMode == 'products') {
            if (
                this.isAllDefaultValues &&
                !this.search &&
                this.pagination.page === 1
            ) {
                await this.updateProductsListFunc(1)
            } else {
                await this.updateProductsList(this.pagination.page, true)
            }
        }

        // this.getLists()
        this.setFilters()
    },
    async destroyed() {
        this.clearProducts()
    },
    methods: {
        ...mapMutations('publicProducts', ['SET_PAGINATION']),
        ...mapActions('publicProducts', ['setSort', 'setPagination']),
        ...mapActions('publicProducts', ['getProducts']),
        ...mapActions('publicProducts', ['clearProducts']),
        ...mapActions('publicLists', ['getLists']),
        ...mapActions('categories', ['getCategories']),
        ...mapActions('types', ['getTypes']),
        ...mapActions('materials', ['getMaterials']),
        ...mapActions('finenesses', ['getFineness']),
        ...mapActions('insert', ['getInsertMaterials']),
        ...mapActions('collections', ['getCollections']),
        ...mapActions('genders', ['getGenders']),
        ...mapActions(['setCartPublicFromLocStor', 'clearPublicSearchGlobal']),
        onSelectPickerChange(type, val) {
            this.loading = true
            this.filter[type].value = val
            this.onFilterChange(type)
        },
        setPreset() {
            const preset = localStorage.getItem('retailer-catalog-data')

            if (preset) {
                const { filter, view, search, pagination, sort } = JSON.parse(
                    preset
                )

                this.filter = filter
                this.view = view
                this.search = search
                this.setPagination(pagination)
                // this.sort = sort
                this.setSort(sort)
            }
        },
        setFilters() {
            const filtersQueries = []

            filtersQueries.push(
                this.getCategories({
                    existing: true,
                    sort_by: 'Position',
                    brand_id: this.brand.BrandID,
                    no_counts: 1
                })
            )

            filtersQueries.push(
                this.getTypes({
                    existing: true,
                    brand_id: this.brand.BrandID
                })
            )

            filtersQueries.push(
                this.getMaterials({
                    existing: true,
                    brand_id: this.brand.BrandID
                })
            )

            filtersQueries.push(
                this.getFineness({
                    existing: true,
                    brand_id: this.brand.BrandID
                })
            )

            filtersQueries.push(
                this.getInsertMaterials({
                    existing: true,
                    brand_id: this.brand.BrandID
                })
            )

            filtersQueries.push(
                // eslint-disable-next-line
                this.getCollections({ existing: true })
            )

            this.getGenders({
                existing: true,
                brand_id: this.brand.BrandID
            })

            return Promise.all(filtersQueries).then(() => {
                this.filtersLoading = false
            })

            // this.getPurposes()

            /* //для не установленных в beforeRouteEnter фильтров выставляем начальные дефолтные значения
            Object.keys(this.filter)
                .filter(item => this.filter[item].isDefault)
                .forEach(filterKey => {
                    this.filter[filterKey].value = this[
                        this.filter[filterKey].defaultValArrName
                    ]
                })*/
        },
        setlevel2mFilters(filterKey) {
            this.level2mFilter = filterKey
        },
        changeListView(type) {
            this.view = type
            if (this.catalogMode !== 'products') {
                this.toggleCatalogMode('products')
            }
        },
        resetFilters() {
            this.loading = true
            Object.keys(this.filter).forEach(item => {
                this.filter[item].value = []
            })

            Object.keys(this.filter).forEach(
                item => (this.filter[item].isDefault = true)
            )

            this.closeAllmFilters()

            this.$emit('resetFilters')

            switch (this.catalogMode) {
                case 'products':
                    this.updateProductsList(1)
                    break
                case 'garnitures':
                    this.handleUpdateGarnituresList()
                    break
            }
        },
        closeAllmFilters() {
            this.level2mFilter = false
            this.level1mFilter = false
        },
        getNameById_old(filterKey, filterValue) {
            const src = this[this.filter[filterKey].srcName]

            const item = src.find(el => {
                if (el[this.filter[filterKey].srcKeyVal] == filterValue) {
                    return el
                }
            })

            if (item) return item[this.filter[filterKey].srcKeyTitle]
            return ''
        },
        onFilterChange(filterType) {
            this.filter[filterType].isDefault = !this.filter[filterType].value
                .length

            if (filterType === 'garnitures') {
                if (this.filter.garnitures.value.length) {
                    this.setSort('Article:asc')
                } else if (this.sort === 'Article:asc') {
                    this.setSort('New:dsc')
                }
            }

            switch (this.catalogMode) {
                case 'products':
                    this.updateProductsList(1)
                    break
                case 'garnitures':
                    this.handleUpdateGarnituresList()
                    break
            }
        },
        updateProductsList: _.debounce(function(
            page = 1,
            isMobilePagination = false
        ) {
            this.updateProductsListFunc(page, isMobilePagination)
        },
        800),
        async updateProductsListFunc(page = 1, isMobilePagination = false) {
            this.loading = true
            this.$Progress.start()

            const data = {
                page,
                sort_by: this.sort.split(':')[0],
                sort_type: this.sort.split(':')[1],
                isMobilePagination,
                'brands[]': this.$route.params.id
            }

            const dataForCategory = {
                page,
                sort_by: this.sort.split(':')[0],
                sort_type: this.sort.split(':')[1],
                isMobilePagination,
                'categories[]': this.$route.params.id
            }

            const dataForSearch = {
                page,
                sort_by: this.sort.split(':')[0],
                sort_type: this.sort.split(':')[1],
                isMobilePagination,
                search: this.publicSearchGlobal
            }

            const dataForAll = {
                page,
                sort_by: this.sort.split(':')[0],
                sort_type: this.sort.split(':')[1],
                isMobilePagination
            }

            Object.keys(this.filter).forEach(item => {
                if (!this.filter[item].isDefault) {
                    let valuesArr = [...this.filter[item].value]

                    if (item === 'finenesses') {
                        valuesArr = [...this.finenessesNamesArr]
                    }

                    if (!valuesArr.length) {
                        valuesArr = [null]
                    }

                    data[this.filter[item].apiFilterName] = valuesArr
                    dataForCategory[this.filter[item].apiFilterName] = valuesArr
                    dataForSearch[this.filter[item].apiFilterName] = valuesArr
                    dataForAll[this.filter[item].apiFilterName] = valuesArr
                }
            })

            if (this.search) {
                data.search = this.search
            }

            if (this.publicSearchGlobal) {
                await this.getProducts(dataForSearch)
            } else if (
                !this.publicSearchGlobal &&
                this.$route.params.id === 'all'
            ) {
                await this.getProducts(dataForAll)
            } else if (this.requestForCategories) {
                await this.getProducts(dataForCategory)
            } else {
                await this.getProducts(data)
            }

            this.loading = false
        },
        onSetPage(page) {
            let validPage = page
            if (page < 1) {
                validPage = 1
            } else if (page > this.pagination.totalPages) {
                validPage = this.pagination.totalPages
            }

            this.SET_PAGINATION({
                key: 'page',
                val: validPage
            })

            this.updateProductsList(page)
        },
        onPageSizeChange(val) {
            this.SET_PAGINATION({
                key: 'pageSize',
                val
            })

            this.updateProductsList(1)
        },

        onSearch() {
            this.$Progress.start()
            switch (this.catalogMode) {
                case 'products':
                    this.updateProductsList(1)
                    break
                case 'garnitures':
                    this.handleUpdateGarnituresList()
                    break
            }
        },
        onClearSearch() {
            this.search = ''
            this.$Progress.start()

            switch (this.catalogMode) {
                case 'products':
                    this.updateProductsList(1)
                    break
                case 'garnitures':
                    this.handleUpdateGarnituresList()
                    break
            }
        },
        onSortChange(value) {
            this.setSort(value)

            this.updateProductsList(1)
        },
        toggleCatalogMode(val) {
            this.catalogMode = val
            if (val == 'products') {
                this.loading = true
                this.clearProducts()
                this.updateProductsList(1)
            }
        },
        handleUpdateGarnituresList() {
            this.garnituresFilterTimeStamp = '' + Date.now()
        }
    }
}
</script>
